import {apiClient} from 'common/util/api-client';
import {Dashboard} from 'common/report/dashboards/types';
import {Content} from 'common/types/app-api/content';

import {appApiUrl} from '../utils';

export interface ContentSidenavResponse {
  favorites: Array<Dashboard | Content>;
  pinned: Array<Dashboard | Content>;
  created: Array<Dashboard | Content>;
}

export interface ContentSidenavOrdering {
  favorites_order: Array<number | string>;
  pinned_order: Array<number | string>;
  created_by_user_order: Array<number | string>;
}

function getUrl(projectId: string | number) {
  return appApiUrl(`content-sidenav`, {projectId});
}

export async function getContentSidenav(projectId: string | number): Promise<ContentSidenavResponse> {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const {favorites, pinned, created} = await apiClient.get<ContentSidenavResponse>(getUrl(projectId));

  return {
    favorites: favorites ?? [],
    pinned: pinned ?? [],
    created: created ?? [],
  };
}

export async function updateContentSidenavOrdering(ordering: ContentSidenavOrdering, projectId: string | number) {
  return apiClient.put(getUrl(projectId), ordering);
}
